<template>
   <div :class="heigth ? 'h-[100%]' : ''">
        <!-- DRAG & DROP -->
        <div v-if="format" :class="heigth ? 'h-[100%]' : ''">
            <div
                :class="heigth ? 'h-[100%]' : ''"
                @dragover="dragover"
                @dragleave="dragleave"
                @drop="drop"
            >
                <input
                    :id="id"
                    type="file"
                    multiple
                    :name="'fields[' + id + '][]'"
                    class="drag-drop--input overflow-hidden absolute"
                    @change="onChange"
                    ref="file"
                    :accept="format.extension"
                />

                <div class="drag-drop" :class="heigth ? 'h-[100%]' : ''">
                    <div class="drag-drop--text">
                        <label
                        :for="''+id"
                        ><slot></slot></label>
                        <slot name="error"></slot>
                    </div>
                    <slot name="btn"></slot>
                </div>
            </div>
        </div>

   </div>
</template>

<script>
import heic2any from "heic2any";
export default {
    props: {
        format: {},
        id: {},
        p_filelist: {},
        heigth: {default :false},
        multiple: {default: false},
        reset: {default: false},
        convertHeic: {default: false},
        hevec: {default: false},
    },
    data() {
        return {
            filelist: [],
        };
    },
    watch: {
        p_filelist() {
            this.filelist = this.p_filelist
        }
    },
    methods: {
        /* ------------------------------- */
        onChange() {
            if(this.reset){
                this.filelist = []
            }
            if(this.$refs.file && this.$refs.file.files){
                if(!this.multiple){
                    if(this.format.format.includes(this.$refs.file.files[0].type) || (this.hevec && this.$refs.file.files[0].name.includes(".hevc"))){

                        this.filelist.push(this.$refs.file.files[0])
                    }
                } else {
                    this.$refs.file.files.forEach(file => {
                        if(this.format.format.includes(file.type) || (this.hevec && file.name.includes(".hevc"))){
                            this.filelist.push(file)
                        }
                    })
                }
            }

            if(this.convertHeic){
                let filelistHeic = []
                this.filelist.forEach((file, i) => {
                    file.show_name = file.name
                    if(file.type == "image/heic" || file.type == "image/heif"){
                        filelistHeic.push(i)
                    }
                });
    
                if(filelistHeic.length > 0){
    
                    filelistHeic.forEach(i => {    
    
                        heic2any({
                            blob: this.filelist[i],
                            toType: "image/jpeg",
                            quality: 0.5,
                            preserveExif: true,
                        }).then((blob) => {
                            let ext = this.filelist[i].name.split(".").pop()
                            let file = new File([blob], this.filelist[i].name.replace(ext,"jpeg"), {
                                type: "image/jpeg",
                                lastModified: Date.now(),
                            });
                            file.show_name = this.filelist[i].name
                            
                            this.filelist[i] = file
                        });
                    });
                }
            }

            this.$emit("fileListChange",this.filelist)
        },
        remove(i) {
            this.filelist.splice(i, 1);
            this.$emit("fileListChange",this.filelist)
        },
        dragover(event) {
            event.preventDefault();
            if (!event.currentTarget.classList.contains("bg-green-300")) {
                event.currentTarget.classList.remove("bg-gray-100");
                event.currentTarget.classList.add("bg-green-300");
            }
        },
        dragleave(event) {
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
        drop(event) {
            event.preventDefault();
            this.$refs.file.files = event.dataTransfer.files;
            this.onChange();
            event.currentTarget.classList.add("bg-gray-100");
            event.currentTarget.classList.remove("bg-green-300");
        },
    },
    created() {
    },
};
</script>

<style lang="scss" scoped>
.drag-drop {
   padding: 5rem;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;

   border: 3px dotted #707070;
   transition: background 0.3s ease;

   &:hover {
      background: rgba($primary, 0.05);
   }

   &--input {
      display: none;
   }

   &--text {
      text-align: center;
      label {
         cursor: pointer;
      }
   }

   &--list {
      list-style: none;
      padding-left: 0;
      margin-top: 2rem;
      margin-bottom: 0;
      &--item {
         span.remove {
            color: $red;
            font-weight: 700;
            margin-right: 1rem;
         }
      }
   }

    small{
        max-width: 40vw;
        overflow: hidden;
        display: block;
    }

}



.controls {
   &--container {
      display: flex;
      justify-content: space-between;
      .v-btn:not(:first-child) {
         margin-left: 1rem;
      }
   }
   &--first {
   }
   &--last {
   }
}

.imgs-not-found{
   margin-top: 3rem;
   *{
      font-weight: 700;
      font-family: 'Oswald';
      font-size: 35px;
      text-align: center;
   }
}
</style>